import { Board } from '../board';
import { BoardSnapshot } from '../board-snapshot';
import { Pile } from '../card/pile';
import { GameLogicDepth } from '../game-logic-depth';
import { Action } from './action';

export class PlaceCardsBackToDeckAction implements Action {
  private board: Board;
  private gameLogicDepth: GameLogicDepth;
  private lastSnapshot: BoardSnapshot | undefined;
  private lastCardIndices: number[] = [];

  constructor(board: Board, gameLogicDepth: GameLogicDepth) {
    this.board = board;
    this.gameLogicDepth = gameLogicDepth;
  }

  public saveSnapshot(): void {
    this.lastSnapshot = this.board.boardSnapshot;
    this.board.boardSnapshot = new BoardSnapshot(
      this.lastSnapshot.foundations,
      this.lastSnapshot.tableaus,
      this.lastSnapshot.deck,
      this.lastSnapshot.waste,
    );
  }

  public execute(): void {
    this.saveSnapshot();

    this.lastCardIndices = Pile.closeCardsBackToDeck(
      this.board.waste,
      this.board.deck,
      this.gameLogicDepth,
    );

    // Clear the waste pile
    this.board.waste.removeAllCards();
  }

  public undo(): void {
    this.lastCardIndices.forEach((cardIndex) => {
      this.gameLogicDepth.updateCardDepth(cardIndex);
    });
    if (this.lastSnapshot !== undefined) {
      this.board.boardSnapshot = this.lastSnapshot;
    }
  }
}
